module.exports = __webpack_public_path__ + "static/media/animation_500_kgtd8u9z.a568962a.gif";